import React from 'react';
import { COLOR_GREY, WHITE, BLACK } from '../../constants';
import { isDarkTheme } from '../../utils'
const getStyles = () => {
  const isDark = isDarkTheme();

  const floatingThresholdProgressContainer: React.CSSProperties = {
    position: 'fixed',
    bottom: 20,
    right: 10,
    left: window.innerWidth <= 500 ? 10 : undefined,
    backgroundColor: isDark ? BLACK : WHITE,
    borderRadius: '20px',
    boxShadow: '3px 3px 10px -6px grey',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    zIndex: 1000,
    border: `1px solid ${isDark ? '#444' : 'lightgray'}`,
  };

  const floatingThresholdTitleContainer = {
    display: 'flex',
    columnGap: 5,
    alignItems: 'center',
    paddingBottom: 10,
    padding: '10px 12px 5px 12px',
  };

  const floatingThresholdTitle: React.CSSProperties = {
    fontSize: window.innerWidth > 320 ? 14 : 11,
    color: isDark ? WHITE : '#444444',
    fontWeight: 500,
    maxWidth: '100%',
  };

  const floatingThresholdSubTitle = {
    fontSize: 10,
    color: isDark ? WHITE : COLOR_GREY,
    fontWeight: 300,
  };

  return {
    floatingThresholdProgressContainer,
    floatingThresholdTitle,
    floatingThresholdTitleContainer,
    floatingThresholdSubTitle,
  };
};

export default getStyles;